import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Appointments from "./pages/Appointments";
import Patients from "./pages/Patients";
import CallLogs from "./pages/CallLogs";
import WhatsApp from "./pages/WhatsApp";
import Settings from "./pages/Settings";
import Signup from "./pages/Signup";
import Onboarding from "./pages/Onboarding";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("clinic_admin_token");
  const onboardingDone = localStorage.getItem("onboarding_completed");
  if (!token) return <Navigate to="/admin/login" replace />;
  if (onboardingDone === "false") return <Navigate to="/onboarding" replace />;
  return children;
}

function OnboardingRoute() {
  const token = localStorage.getItem("clinic_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return <Onboarding />;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/onboarding" element={<OnboardingRoute />} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="patients" element={<Patients />} />
          <Route path="calls" element={<CallLogs />} />
          <Route path="whatsapp" element={<WhatsApp />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
